import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { Topbar } from '@/components/layout/topbar'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { menuItemsQueryOptions, quickStatsQueryOptions } from '@/lib/queries/dashboard'
import { requireStudentAuth } from '@/lib/auth-guard'
import { UserProvider } from '@/contexts/user.context'

export const Route = createFileRoute('/_app')({
    beforeLoad: async () => {
        return await requireStudentAuth()
    },
    loader: async ({ context }) => {
        await Promise.all([
            context.queryClient.fetchQuery(menuItemsQueryOptions()),
            context.queryClient.fetchQuery(quickStatsQueryOptions()),
        ])
    },
    component: AppLayout,
})

function AppLayout() {
    const { profile } = Route.useRouteContext()
    return (
        <UserProvider profile={profile}>
            <SidebarProvider defaultOpen={true}>
                <div className="flex h-screen w-full bg-background">
                    <AppSidebar />

                    <SidebarInset className="flex w-full flex-col min-h-0 overflow-hidden">
                        <Topbar />
                        <main
                            className="flex-1 overflow-y-auto p-4 lg:p-6"
                            style={{ viewTransitionName: 'main-content' }}
                        >
                            <Outlet />
                        </main>
                    </SidebarInset>
                </div>
            </SidebarProvider>
        </UserProvider>
    )
}
